import React, { useState } from 'react'
import { useAuth } from '../../../contexts/AuthContext/AuthContext'
import { LoginFormProps } from './types'
import { validateLoginForm, getErrorMessage } from './helpers'
import { FirebaseError } from '../../../types/errors'
import {
  FormContainer,
  Title,
  Form,
  Input,
  Button,
  ErrorMessage,
  LinkButton,
  LegalLinks,
  LegalLink,
} from './styled'

const LoginForm: React.FC<LoginFormProps> = ({ onToggleMode }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { signIn } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    const validationError = validateLoginForm(email, password)
    if (validationError) {
      setError(validationError)
      return
    }

    setError('')
    setLoading(true)

    try {
      await signIn(email, password)
    } catch (err) {
      setError(getErrorMessage(err as FirebaseError))
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContainer>
      <Title>Sign In</Title>
      <Form onSubmit={handleSubmit}>
        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={loading}
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={loading}
        />
        <Button type="submit" disabled={loading}>
          {loading ? 'Signing In...' : 'Sign In'}
        </Button>
      </Form>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <LinkButton type="button" onClick={onToggleMode}>
        Don't have an account? Sign up
      </LinkButton>
      <LegalLinks>
        <LegalLink href="/privacy">Privacy Policy</LegalLink>
        <span>•</span>
        <LegalLink href="/terms">Terms of Use</LegalLink>
      </LegalLinks>
    </FormContainer>
  )
}

export { LoginForm }
